import { onAuthStateChanged } from "firebase/auth";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { auth, db } from "../firebase";
import { get, ref } from "firebase/database";
import Footer from "../components/Footer";

const LandingPage = () => {
  const navigate = useNavigate();
  const [checkingAuth, setCheckingAuth] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        try {
          const userRef = ref(db, `users/${user.uid}`);
          const snapshot = await get(userRef);

          if (snapshot.exists()) {
            const userData = snapshot.val();
            const role = userData.role;

            if (role === "organizer") {
              navigate("/organizer", { replace: true });
            } else if (role === "bidder") {
              navigate("/bidder", { replace: true });
            } else {
              navigate("/", { replace: true });
            }
          }
        } catch (err) {
          console.error("Error fetching user data:", err);
        }
      }
      setCheckingAuth(false);
    });

    return () => unsubscribe();
  }, [navigate]);

  const [showGuestModal, setShowGuestModal] = useState(false);
  const [guestGameId, setGuestGameId] = useState("");
  const [showPlayerModal, setShowPlayerModal] = useState(false);
  const [playerGameId, setPlayerGameId] = useState("");

  const handleGuestSubmit = (e) => {
    e.preventDefault();
    if (guestGameId.trim()) {
      navigate(`/guest/${guestGameId.trim()}`);
    }
  };

  const handlePlayerSubmit = (e) => {
    e.preventDefault();
    if (playerGameId.trim()) {
      navigate(`/player-reg/${playerGameId.trim()}`);
    }
  };

  if (checkingAuth) {
    return (
      <div className="container mt-5 text-center">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <div className="landing-page">
        <section className="hero-section position-relative py-5 overflow-hidden">
          {/* Animated Background */}
                <div className="hero-background">
                <div className="gradient-overlay"></div>
                <div className="animated-shapes">
                  <div className="shape shape-1"></div>
                  <div className="shape shape-2"></div>
                  <div className="shape shape-3"></div>
                  <div className="shape shape-4"></div>
                </div>
                </div>

                <div className="container position-relative" style={{ zIndex: 2 }}>
                <div className="row align-items-center min-vh-100">
                  <div className="col-lg-6 mb-5 mb-lg-0">
                  <span className="badge bg-primary text-white mb-3 px-3 py-2 animate-fade-in">
                    <i className="bi bi-stars me-2"></i>
                    #1 Free Sports Auction Platform
                  </span>
                  <h1 className="display-2 fw-bold mb-4 animate-fade-in">
                    SportsBid Arena
                  </h1>
                  <h2 className="h4 mb-4 animate-fade-in-delay-1">
                    Free Player Auction Site | Sports Bidding Platform
                  </h2>
                  <p
                    className="lead mb-4 fs-4 animate-fade-in-delay-1"
                    style={{ lineHeight: "1.8" }}
                  >
                    Conduct professional player auctions for any sport - cricket, football, basketball, volleyball, and more. 
                    Our simple and free online bidding platform is perfect for sports tournaments, college leagues, and community events. 
                    Create IPL-style, BPL-style, or custom player auctions with real-time bidding. 
                    Whether you're an organizer, team owner, or player - join thousands using our platform for seamless auction management.
                  </p>
                  <div className="animate-fade-in-delay-2">
                    <div className="row g-3 mb-3">
                      <div className="col-md-6">
                        <Link
                          to="/sign-in"
                          className="btn btn-primary btn-lg w-100 px-4 py-3 shadow-lg hover-grow"
                          aria-label="Start free player auction"
                        >
                          <i className="bi bi-box-arrow-in-right me-2"></i>
                          Start Free Auction
                        </Link>
                      </div>
                      <div className="col-md-6">
                        <Link
                          to="/sign-up"
                          className="btn btn-outline-primary btn-lg w-100 px-4 py-3 hover-grow"
                          aria-label="Sign up for free bidding"
                        >
                          <i className="bi bi-person-plus me-2"></i>
                          Sign Up Free
                        </Link>
                      </div>
                    </div>
                    <div className="row g-3">
                      <div className="col-md-6">
                        <button
                          onClick={() => setShowPlayerModal(true)}
                          className="btn btn-warning btn-lg w-100 px-4 py-3 hover-grow"
                          aria-label="Register as player"
                        >
                          <i className="bi bi-person-badge me-2"></i>
                          Player Registration
                        </button>
                      </div>
                      <div className="col-md-6">
                        <button
                          onClick={() => setShowGuestModal(true)}
                          className="btn btn-info btn-lg w-100 px-4 py-3 hover-grow"
                          aria-label="View live auction as guest"
                        >
                          <i className="bi bi-eye me-2"></i>
                          View Live Auction
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="mt-5 animate-fade-in-delay-3">
                    <div className="row g-4">
                    <div className="col-4">
                      <div className="stat-box">
                      <h2 className="mb-0 fw-bold display-6">1000+</h2>
                      <small className="text-white-50">Free Auctions Conducted</small>
                      </div>
                    </div>
                    <div className="col-4">
                      <div className="stat-box">
                      <h2 className="mb-0 fw-bold display-6">500+</h2>
                      <small className="text-white-50">Active Users Worldwide</small>
                      </div>
                    </div>
                    <div className="col-4">
                      <div className="stat-box">
                      <h2 className="mb-0 fw-bold display-6">4.8★</h2>
                      <small className="text-white-50">User Rating</small>
                      </div>
                    </div>
                    </div>
                  </div>
                  </div>
                  <div className="col-lg-6 text-center animate-fade-in-delay-2">
                  <div className="hero-illustration-3d">
                    <div className="floating-card card-1">
                    <div className="icon-wrapper bg-warning">
                      <i className="bi bi-trophy-fill" aria-hidden="true"></i>
                    </div>
                    </div>
                    <div className="floating-card card-2">
                    <div className="icon-wrapper bg-info">
                      <i className="bi bi-people-fill" aria-hidden="true"></i>
                    </div>
                    </div>
                    <div className="floating-card card-3">
                    <div className="icon-wrapper bg-success">
                      <i className="bi bi-cash-stack" aria-hidden="true"></i>
                    </div>
                    </div>
                    <div className="center-glow"></div>
                  </div>
                  </div>
                </div>
                </div>
              </section>

              {/* Features Section - SEO Optimized */}
        <section
          className="py-5 position-relative overflow-hidden"
          style={{
            background: "linear-gradient(180deg, #f8f9fa 0%, #ffffff 100%)",
          }}
        >
          <div className="roles-pattern"></div>
          <div className="container py-5 position-relative">
            <div className="text-center mb-5">
              <span className="badge bg-primary mb-3 px-3 py-2">
                <i className="bi bi-lightning-fill me-2"></i>
                FREE AUCTION FEATURES
              </span>
              <h2 className="display-4 fw-bold mb-3 text-black">
                Best Free Auction Site for Sports
              </h2>
              <p className="lead text-muted">
                Simple player bidding platform with powerful features for cricket, football, and basketball auctions
              </p>
            </div>

            <div className="row g-4">
              <div className="col-md-6 col-lg-4">
                <article className="feature-card card h-100 border-0 shadow-hover">
                  <div className="card-body p-4">
                    <div className="feature-icon-box bg-primary-soft mb-4">
                      <i className="bi bi-broadcast text-primary" aria-hidden="true"></i>
                    </div>
                    <h3 className="h4 fw-bold mb-3">Real-Time Player Bidding</h3>
                    <p className="text-muted mb-0">
                      Live cricket auction and football player bidding with instant updates. 
                      Conduct IPL-style auctions with real-time bid tracking across all devices.
                    </p>
                  </div>
                </article>
              </div>

              <div className="col-md-6 col-lg-4">
                <article className="feature-card card h-100 border-0 shadow-hover">
                  <div className="card-body p-4">
                    <div className="feature-icon-box bg-success-soft mb-4">
                      <i className="bi bi-shield-fill-check text-success" aria-hidden="true"></i>
                    </div>
                    <h3 className="h4 fw-bold mb-3">Free Team Management</h3>
                    <p className="text-muted mb-0">
                      Create unlimited teams for your cricket or football auction. Manage team budgets, 
                      assign captains, and build squads easily on our free auction platform.
                    </p>
                  </div>
                </article>
              </div>

              <div className="col-md-6 col-lg-4">
                <article className="feature-card card h-100 border-0 shadow-hover">
                  <div className="card-body p-4">
                    <div className="feature-icon-box bg-info-soft mb-4">
                      <i className="bi bi-people-fill text-info" aria-hidden="true"></i>
                    </div>
                    <h3 className="h4 fw-bold mb-3">Player Database Management</h3>
                    <p className="text-muted mb-0">
                      Simple player database for cricket, football, basketball auctions. Add players with photos, 
                      roles, base prices for your sports tournament.
                    </p>
                  </div>
                </article>
              </div>

              <div className="col-md-6 col-lg-4">
                <article className="feature-card card h-100 border-0 shadow-hover">
                  <div className="card-body p-4">
                    <div className="feature-icon-box bg-warning-soft mb-4">
                      <i className="bi bi-gear-fill text-warning" aria-hidden="true"></i>
                    </div>
                    <h3 className="h4 fw-bold mb-3">Flexible Auction Settings</h3>
                    <p className="text-muted mb-0">
                      Customize your cricket or football auction rules. Set purse values, bid increments, 
                      and player limits for your sports league.
                    </p>
                  </div>
                </article>
              </div>

              <div className="col-md-6 col-lg-4">
                <article className="feature-card card h-100 border-0 shadow-hover">
                  <div className="card-body p-4">
                    <div className="feature-icon-box bg-danger-soft mb-4">
                      <i className="bi bi-speedometer2 text-danger" aria-hidden="true"></i>
                    </div>
                    <h3 className="h4 fw-bold mb-3">Live Auction Dashboard</h3>
                    <p className="text-muted mb-0">
                      Monitor player auction progress with real-time analytics. Track team budgets, 
                      player distribution for cricket and football tournaments.
                    </p>
                  </div>
                </article>
              </div>

              <div className="col-md-6 col-lg-4">
                <article className="feature-card card h-100 border-0 shadow-hover">
                  <div className="card-body p-4">
                    <div className="feature-icon-box bg-secondary-soft mb-4">
                      <i className="bi bi-phone-fill text-secondary" aria-hidden="true"></i>
                    </div>
                    <h3 className="h4 fw-bold mb-3">Mobile-Friendly Bidding</h3>
                    <p className="text-muted mb-0">
                      Conduct player auctions from any device. Our simple auction site works perfectly 
                      on mobile phones for cricket and football bidding.
                    </p>
                  </div>
                </article>
              </div>
            </div>
          </div>
        </section>

        {/* How It Works Section */}
        <section className="py-5 position-relative overflow-hidden">
          <div className="workflow-background"></div>
          <div className="container py-5 position-relative">
            <div className="text-center mb-5">
              <span className="badge bg-success mb-3 px-3 py-2">
                <i className="bi bi-diagram-3-fill me-2"></i>
                SIMPLE & FREE PROCESS
              </span>
              <h2 className="display-4 fw-bold mb-3">
                How to Conduct Cricket Auction
              </h2>
              <p className="lead text-muted">
                Start your free player auction in 4 simple steps
              </p>
            </div>

            <div className="row g-4 position-relative">

              <div className="col-md-6 col-lg-3">
                <article className="workflow-step text-center">
                  <div className="step-number-wrapper mb-4">
                    <div className="step-number">1</div>
                  </div>
                  <div className="workflow-icon bg-primary-soft mb-3">
                    <i className="bi bi-person-plus-fill text-primary" aria-hidden="true"></i>
                  </div>
                  <h3 className="h5 fw-bold mb-3">Free Sign Up</h3>
                  <p className="text-muted">
                    Create free account as Organizer or Bidder. No credit card required 
                    for our auction platform.
                  </p>
                </article>
              </div>

              <div className="col-md-6 col-lg-3">
                <article className="workflow-step text-center">
                  <div className="step-number-wrapper mb-4">
                    <div className="step-number">2</div>
                  </div>
                  <div className="workflow-icon bg-success-soft mb-3">
                    <i className="bi bi-gear-fill text-success" aria-hidden="true"></i>
                  </div>
                  <h3 className="h5 fw-bold mb-3">Setup Cricket/Football Auction</h3>
                  <p className="text-muted">
                    Add teams and players for your cricket, football, or basketball tournament. 
                    Simple setup process for sports leagues.
                  </p>
                </article>
              </div>

              <div className="col-md-6 col-lg-3">
                <article className="workflow-step text-center">
                  <div className="step-number-wrapper mb-4">
                    <div className="step-number">3</div>
                  </div>
                  <div className="workflow-icon bg-info-soft mb-3">
                    <i className="bi bi-play-circle-fill text-info" aria-hidden="true"></i>
                  </div>
                  <h3 className="h5 fw-bold mb-3">Start Live Player Bidding</h3>
                  <p className="text-muted">
                    Launch real-time player auction. Teams compete in live bidding 
                    for cricket and football players.
                  </p>
                </article>
              </div>

              <div className="col-md-6 col-lg-3">
                <article className="workflow-step text-center">
                  <div className="step-number-wrapper mb-4">
                    <div className="step-number">4</div>
                  </div>
                  <div className="workflow-icon bg-warning-soft mb-3">
                    <i className="bi bi-graph-up-arrow text-warning" aria-hidden="true"></i>
                  </div>
                  <h3 className="h5 fw-bold mb-3">Track Auction Results</h3>
                  <p className="text-muted">
                    Monitor live stats and view final team rosters for your 
                    cricket or football auction.
                  </p>
                </article>
              </div>
            </div>
          </div>
        </section>

        {/* User Roles Section - SEO Optimized */}
        <section
          className="py-5 position-relative overflow-hidden"
          style={{
            background: "linear-gradient(180deg, #ffffff 0%, #f8f9fa 100%)",
          }}
        >
          <div className="roles-pattern"></div>
          <div className="container py-5 position-relative">
            <div className="text-center mb-5">
              <span className="badge bg-info mb-3 px-3 py-2">
                <i className="bi bi-person-badge-fill me-2"></i>
                FREE FOR EVERYONE
              </span>
              <h2 className="display-4 fw-bold mb-3 text-black">
                Free Auction Platform for Organizers & Bidders
              </h2>
              <p className="lead text-muted">
                Perfect for cricket leagues, football tournaments, and sports events
              </p>
            </div>

            <div className="row g-4 justify-content-center">
              <div className="col-md-6 col-lg-5">
                <article className="role-card card border-0 shadow-lg h-100">
                  <div className="card-body p-5">
                    <div className="text-center mb-4">
                      <div className="role-icon bg-gradient-primary mb-3">
                        <i className="bi bi-person-gear" aria-hidden="true"></i>
                      </div>
                      <h3 className="fw-bold mb-2">Tournament Organizer</h3>
                      <p className="text-muted mb-0">
                        Free auction management for any sport
                      </p>
                      <div className="role-badge">Most Popular</div>
                    </div>
                    <ul className="list-unstyled role-features">
                      <li className="mb-3">
                        <i className="bi bi-check-circle-fill text-success me-2" aria-hidden="true"></i>
                        Create free player auctions for any sport
                      </li>
                      <li className="mb-3">
                        <i className="bi bi-check-circle-fill text-success me-2" aria-hidden="true"></i>
                        Manage teams for sports leagues
                      </li>
                      <li className="mb-3">
                        <i className="bi bi-check-circle-fill text-success me-2" aria-hidden="true"></i>
                        Upload player database for auctions
                      </li>
                      <li className="mb-3">
                        <i className="bi bi-check-circle-fill text-success me-2" aria-hidden="true"></i>
                        Control live player bidding flow
                      </li>
                      <li className="mb-3">
                        <i className="bi bi-check-circle-fill text-success me-2" aria-hidden="true"></i>
                        View real-time auction analytics
                      </li>
                      <li className="mb-3">
                        <i className="bi bi-check-circle-fill text-success me-2" aria-hidden="true"></i>
                        Start IPL-style or custom auctions
                      </li>
                    </ul>
                    <Link
                      to="/sign-up"
                      className="btn btn-primary btn-lg w-100 mt-3 hover-grow"
                      aria-label="Sign up as free tournament organizer"
                    >
                      <i className="bi bi-rocket-takeoff-fill me-2"></i>
                      Start Free Auction
                    </Link>
                  </div>
                </article>
              </div>

              <div className="col-md-6 col-lg-5">
                <article className="role-card card border-0 shadow-lg h-100">
                  <div className="card-body p-5">
                    <div className="text-center mb-4">
                      <div className="role-icon bg-gradient-success mb-3">
                        <i className="bi bi-hand-thumbs-up" aria-hidden="true"></i>
                      </div>
                      <h3 className="fw-bold mb-2">Team Owner / Bidder</h3>
                      <p className="text-muted mb-0">
                        Free player bidding in sports auctions
                      </p>
                      <div className="role-badge-alt">Free for Team Owners</div>
                    </div>
                    <ul className="list-unstyled role-features">
                      <li className="mb-3">
                        <i className="bi bi-check-circle-fill text-success me-2" aria-hidden="true"></i>
                        Join free player auctions
                      </li>
                      <li className="mb-3">
                        <i className="bi bi-check-circle-fill text-success me-2" aria-hidden="true"></i>
                        Place real-time bids on players
                      </li>
                      <li className="mb-3">
                        <i className="bi bi-check-circle-fill text-success me-2" aria-hidden="true"></i>
                        Track your team budget and purse
                      </li>
                      <li className="mb-3">
                        <i className="bi bi-check-circle-fill text-success me-2" aria-hidden="true"></i>
                        Build your dream sports squad
                      </li>
                      <li className="mb-3">
                        <i className="bi bi-check-circle-fill text-success me-2" aria-hidden="true"></i>
                        Monitor all teams and player prices
                      </li>
                      <li className="mb-3">
                        <i className="bi bi-check-circle-fill text-success me-2" aria-hidden="true"></i>
                        Compete in live tournaments
                      </li>
                    </ul>
                    <Link
                      to="/sign-up"
                      className="btn btn-success btn-lg w-100 mt-3 hover-grow"
                      aria-label="Sign up as free bidder"
                    >
                      <i className="bi bi-trophy-fill me-2"></i>
                      Join Free Bidding
                    </Link>
                  </div>
                </article>
              </div>

              {/* Guest and Player Cards - Second Row */}
              <div className="col-md-6 col-lg-5">
                <article className="role-card card border-0 shadow-lg h-100">
                  <div className="card-body p-5">
                    <div className="text-center mb-4">
                      <div className="role-icon bg-gradient-info mb-3" style={{background: "linear-gradient(135deg, #17a2b8 0%, #138496 100%)"}}>
                        <i className="bi bi-eye" aria-hidden="true"></i>
                      </div>
                      <h3 className="fw-bold mb-2">Guest Viewer</h3>
                      <p className="text-muted mb-0">
                        Watch live auctions without signing up
                      </p>
                    </div>
                    <ul className="list-unstyled role-features">
                      <li className="mb-3">
                        <i className="bi bi-check-circle-fill text-success me-2" aria-hidden="true"></i>
                        View live player auctions in real-time
                      </li>
                      <li className="mb-3">
                        <i className="bi bi-check-circle-fill text-success me-2" aria-hidden="true"></i>
                        No sign up required
                      </li>
                      <li className="mb-3">
                        <i className="bi bi-check-circle-fill text-success me-2" aria-hidden="true"></i>
                        Watch bidding wars unfold live
                      </li>
                      <li className="mb-3">
                        <i className="bi bi-check-circle-fill text-success me-2" aria-hidden="true"></i>
                        See current player prices
                      </li>
                      <li className="mb-3">
                        <i className="bi bi-check-circle-fill text-success me-2" aria-hidden="true"></i>
                        Track team budgets and rosters
                      </li>
                      <li className="mb-3">
                        <i className="bi bi-check-circle-fill text-success me-2" aria-hidden="true"></i>
                        Perfect for spectators and fans
                      </li>
                    </ul>
                    <button
                      onClick={() => setShowGuestModal(true)}
                      className="btn btn-info btn-lg w-100 mt-3 hover-grow"
                      aria-label="View as guest"
                    >
                      <i className="bi bi-eye-fill me-2"></i>
                      View Live Auction
                    </button>
                  </div>
                </article>
              </div>

              <div className="col-md-6 col-lg-5">
                <article className="role-card card border-0 shadow-lg h-100">
                  <div className="card-body p-5">
                    <div className="text-center mb-4">
                      <div className="role-icon bg-gradient-warning mb-3" style={{background: "linear-gradient(135deg, #ffc107 0%, #ff9800 100%)"}}>
                        <i className="bi bi-person-badge" aria-hidden="true"></i>
                      </div>
                      <h3 className="fw-bold mb-2">Player</h3>
                      <p className="text-muted mb-0">
                        Register yourself for upcoming auctions
                      </p>
                    </div>
                    <ul className="list-unstyled role-features">
                      <li className="mb-3">
                        <i className="bi bi-check-circle-fill text-success me-2" aria-hidden="true"></i>
                        Register for player auctions
                      </li>
                      <li className="mb-3">
                        <i className="bi bi-check-circle-fill text-success me-2" aria-hidden="true"></i>
                        Submit your player profile
                      </li>
                      <li className="mb-3">
                        <i className="bi bi-check-circle-fill text-success me-2" aria-hidden="true"></i>
                        Set your base price preference
                      </li>
                      <li className="mb-3">
                        <i className="bi bi-check-circle-fill text-success me-2" aria-hidden="true"></i>
                        Add your sports skills and role
                      </li>
                      <li className="mb-3">
                        <i className="bi bi-check-circle-fill text-success me-2" aria-hidden="true"></i>
                        Track which team picks you
                      </li>
                      <li className="mb-3">
                        <i className="bi bi-check-circle-fill text-success me-2" aria-hidden="true"></i>
                        Join tournaments and leagues
                      </li>
                    </ul>
                    <button
                      onClick={() => setShowPlayerModal(true)}
                      className="btn btn-warning btn-lg w-100 mt-3 hover-grow"
                      aria-label="Register as player"
                    >
                      <i className="bi bi-person-plus-fill me-2"></i>
                      Register as Player
                    </button>
                  </div>
                </article>
              </div>
            </div>
          </div>
        </section>

        {/* Sports Supported Section - SEO Enhanced */}
        <section className="py-5 position-relative overflow-hidden">
          <div className="workflow-background"></div>
          <div className="container py-5 position-relative">
            <div className="text-center mb-5">
              <span className="badge bg-primary text-white mb-3 px-3 py-2">
                <i className="bi bi-trophy me-2"></i>
                MULTIPLE SPORTS SUPPORTED
              </span>
              <h2 className="display-4 fw-bold mb-3">
                Free Auction Site for All Sports
              </h2>
              <p className="lead">
                Cricket auction, football auction, basketball auction - all sports player bidding made simple
              </p>
            </div>

            <div className="row g-4 text-center">
              <div className="col-6 col-md-3">
                <article className="sport-card">
                  <div className="sport-emoji" role="img" aria-label="Cricket">🏏</div>
                  <h3 className="h5 fw-bold">Cricket Auction</h3>
                  <p className="small text-muted mb-0">
                    IPL-style cricket player auctions
                  </p>
                </article>
              </div>
              <div className="col-6 col-md-3">
                <article className="sport-card">
                  <div className="sport-emoji" role="img" aria-label="Football">⚽</div>
                  <h3 className="h5 fw-bold">Football Auction</h3>
                  <p className="small text-muted mb-0">
                    Football player bidding for leagues
                  </p>
                </article>
              </div>
              <div className="col-6 col-md-3">
                <article className="sport-card">
                  <div className="sport-emoji" role="img" aria-label="Basketball">🏀</div>
                  <h3 className="h5 fw-bold">Basketball Auction</h3>
                  <p className="small text-muted mb-0">
                    Basketball player auctions and bidding
                  </p>
                </article>
              </div>
              <div className="col-6 col-md-3">
                <article className="sport-card">
                  <div className="sport-emoji" role="img" aria-label="Volleyball">🏐</div>
                  <h3 className="h5 fw-bold">Volleyball Auction</h3>
                  <p className="small text-muted mb-0">
                    Volleyball tournament player auctions
                  </p>
                </article>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section - SEO Optimized */}
        <section
          className="py-5 position-relative overflow-hidden"
          style={{
            background: "linear-gradient(180deg, #ffffff 0%, #f8f9fa 100%)",
          }}
        >
          <div className="roles-pattern"></div>
          <div className="container py-5 position-relative">
            <div className="row align-items-center">
              <div className="col-lg-8 mb-4 mb-lg-0">
                <h2 className="display-4 fw-bold mb-3 text-black">
                  Start Your Free Cricket or Football Auction Today
                </h2>
                <p className="lead mb-0">
                  Join hundreds of organizers conducting successful player auctions. 
                  Free bidding platform for cricket, football, and basketball tournaments. 
                  Simple auction site with no hidden costs.
                </p>
              </div>
              <div className="col-lg-4 text-lg-end">
                <Link
                  to="/sign-up"
                  className="btn btn-primary btn-lg px-5 py-3 shadow-lg hover-grow"
                  aria-label="Get started with free auction"
                >
                  <i className="bi bi-rocket-takeoff-fill me-2"></i>
                  Get Started Free
                </Link>
              </div>
            </div>
          </div>
        </section>

        {/* Footer */}
        <Footer variant="full" />

        {/* Guest Modal */}
        {showGuestModal && (
          <div
            className="modal d-block"
            style={{ background: "rgba(0, 0, 0, 0.7)" }}
            role="dialog"
            aria-labelledby="guestModalTitle"
            aria-modal="true"
          >
            <div className="modal-dialog modal-dialog-centered">
              <div
                className="modal-content shadow-lg border-0"
                style={{ borderRadius: "20px", overflow: "hidden" }}
              >
                <div
                  className="modal-header text-white"
                  style={{
                    background: "#17a2b8",
                  }}
                >
                  <h5 className="modal-title fw-bold" id="guestModalTitle">
                    <i className="bi bi-eye-fill me-2" aria-hidden="true"></i>
                    View Live Player Auction as Guest
                  </h5>
                  <button
                    type="button"
                    className="btn-close btn-close-white"
                    onClick={() => setShowGuestModal(false)}
                    aria-label="Close modal"
                  ></button>
                </div>
                <form onSubmit={handleGuestSubmit}>
                  <div className="modal-body p-4">
                    <p className="text-muted mb-4">
                      Enter the Game ID to view live player auction in real-time without signing in. 
                      Watch cricket, football, basketball, or any sports bidding as it happens.
                    </p>
                    <div className="mb-3">
                      <label htmlFor="gameIdInput" className="form-label fw-semibold">
                        <i className="bi bi-hash me-2" aria-hidden="true"></i>
                        Game ID
                      </label>
                      <input
                        type="text"
                        id="gameIdInput"
                        className="form-control form-control-lg"
                        placeholder="e.g., AUC-123456"
                        value={guestGameId}
                        onChange={(e) => setGuestGameId(e.target.value)}
                        required
                        autoFocus
                        aria-required="true"
                      />
                      <small className="text-muted">
                        Get the Game ID from your tournament organizer
                      </small>
                    </div>
                  </div>
                  <div className="modal-footer border-0 bg-light">
                    <button
                      type="button"
                      className="btn btn-secondary"
                      onClick={() => setShowGuestModal(false)}
                    >
                      Cancel
                    </button>
                    <button type="submit" className="btn btn-info">
                      <i className="bi bi-arrow-right-circle me-2" aria-hidden="true"></i>
                      View Live Auction
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        )}

        {/* Player Modal */}
        {showPlayerModal && (
          <div
            className="modal d-block"
            style={{ background: "rgba(0, 0, 0, 0.7)" }}
            role="dialog"
            aria-labelledby="playerModalTitle"
            aria-modal="true"
          >
            <div className="modal-dialog modal-dialog-centered">
              <div
                className="modal-content shadow-lg border-0"
                style={{ borderRadius: "20px", overflow: "hidden" }}
              >
                <div
                  className="modal-header text-white"
                  style={{
                    background: "linear-gradient(135deg, #ffc107 0%, #ff9800 100%)",
                  }}
                >
                  <h5 className="modal-title fw-bold" id="playerModalTitle">
                    <i className="bi bi-person-badge-fill me-2" aria-hidden="true"></i>
                    Register as Player
                  </h5>
                  <button
                    type="button"
                    className="btn-close btn-close-white"
                    onClick={() => setShowPlayerModal(false)}
                    aria-label="Close modal"
                  ></button>
                </div>
                <form onSubmit={handlePlayerSubmit}>
                  <div className="modal-body p-4">
                    <p className="text-muted mb-4">
                      Enter the Game ID to register yourself for an upcoming player auction. 
                      You'll be able to submit your profile, skills, and preferences.
                    </p>
                    <div className="mb-3">
                      <label htmlFor="playerGameIdInput" className="form-label fw-semibold">
                        <i className="bi bi-hash me-2" aria-hidden="true"></i>
                        Game ID
                      </label>
                      <input
                        type="text"
                        id="playerGameIdInput"
                        className="form-control form-control-lg"
                        placeholder="e.g., AUC-123456"
                        value={playerGameId}
                        onChange={(e) => setPlayerGameId(e.target.value)}
                        required
                        autoFocus
                        aria-required="true"
                      />
                      <small className="text-muted">
                        Get the Game ID from your tournament organizer
                      </small>
                    </div>
                  </div>
                  <div className="modal-footer border-0 bg-light">
                    <button
                      type="button"
                      className="btn btn-secondary"
                      onClick={() => setShowPlayerModal(false)}
                    >
                      Cancel
                    </button>
                    <button type="submit" className="btn btn-warning">
                      <i className="bi bi-arrow-right-circle me-2" aria-hidden="true"></i>
                      Continue to Registration
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        )}

        <style jsx>{`
          /* Hero Section Background */
          .hero-section {
            position: relative;
          }

          .hero-background {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            overflow: hidden;
          }

          .gradient-overlay {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: transparent;
          }

          .animated-shapes {
            position: absolute;
            width: 100%;
            height: 100%;
          }

          .shape {
            position: absolute;
            border-radius: 50%;
            background: rgba(102, 126, 234, 0.05);
            animation: float 20s infinite ease-in-out;
          }

          .shape-1 {
            width: 300px;
            height: 300px;
            top: 10%;
            left: 10%;
            animation-delay: 0s;
          }

          .shape-2 {
            width: 200px;
            height: 200px;
            top: 60%;
            right: 10%;
            animation-delay: 5s;
          }

          .shape-3 {
            width: 150px;
            height: 150px;
            bottom: 10%;
            left: 30%;
            animation-delay: 10s;
          }

          .shape-4 {
            width: 250px;
            height: 250px;
            top: 30%;
            right: 30%;
            animation-delay: 15s;
          }

          @keyframes float {
            0%,
            100% {
              transform: translate(0, 0) scale(1);
            }
            25% {
              transform: translate(30px, -30px) scale(1.1);
            }
            50% {
              transform: translate(-20px, 20px) scale(0.9);
            }
            75% {
              transform: translate(20px, 30px) scale(1.05);
            }
          }

          /* 3D Hero Illustration */
          .hero-illustration-3d {
            position: relative;
            height: 400px;
          }

          .floating-card {
            position: absolute;
            animation: float-card 6s infinite ease-in-out;
          }

          .floating-card .icon-wrapper {
            width: 120px;
            height: 120px;
            border-radius: 20px;
            display: flex;
            align-items: center;
            justify-content: center;
            box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
            backdrop-filter: blur(10px);
          }

          .floating-card i {
            font-size: 3rem;
            color: white;
          }

          .card-1 {
            top: 0;
            left: 0;
            animation-delay: 0s;
          }

          .card-2 {
            top: 50%;
            right: 0;
            animation-delay: 2s;
          }

          .card-3 {
            bottom: 0;
            left: 50%;
            transform: translateX(-50%);
            animation-delay: 4s;
          }

          .center-glow {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 200px;
            height: 200px;
            background: radial-gradient(
              circle,
              rgba(255, 255, 255, 0.3) 0%,
              transparent 70%
            );
            animation: pulse 3s infinite ease-in-out;
          }

          @keyframes float-card {
            0%,
            100% {
              transform: translateY(0px);
            }
            50% {
              transform: translateY(-20px);
            }
          }

          @keyframes pulse {
            0%,
            100% {
              transform: translate(-50%, -50%) scale(1);
              opacity: 0.5;
            }
            50% {
              transform: translate(-50%, -50%) scale(1.2);
              opacity: 0.8;
            }
          }

          /* Feature Section Patterns */
          .feature-pattern {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-image: radial-gradient(
                circle at 20% 50%,
                rgba(102, 126, 234, 0.05) 0%,
                transparent 50%
              ),
              radial-gradient(
                circle at 80% 80%,
                rgba(118, 75, 162, 0.05) 0%,
                transparent 50%
              );
          }

          .feature-icon-box {
            width: 80px;
            height: 80px;
            border-radius: 20px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 2rem;
          }

          .bg-primary-soft {
            background: rgba(102, 126, 234, 0.1);
          }
          .bg-success-soft {
            background: rgba(40, 167, 69, 0.1);
          }
          .bg-info-soft {
            background: rgba(23, 162, 184, 0.1);
          }
          .bg-warning-soft {
            background: rgba(255, 193, 7, 0.1);
          }
          .bg-danger-soft {
            background: rgba(220, 53, 69, 0.1);
          }
          .bg-secondary-soft {
            background: rgba(108, 117, 125, 0.1);
          }

          .shadow-hover {
            transition: all 0.3s ease;
          }

          .shadow-hover:hover {
            transform: translateY(-10px);
            box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1) !important;
          }

          /* Workflow Section */
          .workflow-background {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: linear-gradient(
                45deg,
                transparent 45%,
                rgba(102, 126, 234, 0.03) 45%,
                rgba(102, 126, 234, 0.03) 55%,
                transparent 55%
              ),
              linear-gradient(
                -45deg,
                transparent 45%,
                rgba(118, 75, 162, 0.03) 45%,
                rgba(118, 75, 162, 0.03) 55%,
                transparent 55%
              );
            background-size: 60px 60px;
          }

          .workflow-line {
            position: absolute;
            top: 120px;
            left: 12.5%;
            right: 12.5%;
            height: 4px;
            background: linear-gradient(90deg, #667eea 0%, #764ba2 100%);
            z-index: 0;
          }

          .workflow-step {
            position: relative;
            z-index: 1;
          }

          .step-number-wrapper {
            display: inline-block;
          }

          .step-number {
            width: 60px;
            height: 60px;
            border-radius: 50%;
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            color: white;
            font-size: 1.5rem;
            font-weight: bold;
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 0 auto;
            box-shadow: 0 10px 30px rgba(102, 126, 234, 0.3);
          }

          .workflow-icon {
            width: 80px;
            height: 80px;
            border-radius: 20px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 0 auto;
            font-size: 2rem;
          }

          /* Roles Section */
          .roles-pattern {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-image: linear-gradient(
              30deg,
              transparent 12%,
              rgba(102, 126, 234, 0.03) 12%,
              rgba(102, 126, 234, 0.03) 88%,
              transparent 88%
            );
            background-size: 100px 100px;
          }

          .role-card {
            transition: all 0.3s ease;
            overflow: hidden;
          }

          .role-card:hover {
            transform: translateY(-10px);
          }

          .role-icon {
            width: 100px;
            height: 100px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 0 auto;
            font-size: 3rem;
            color: white;
            box-shadow: 0 15px 35px rgba(0, 0, 0, 0.2);
          }

          .bg-gradient-primary {
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          }

          .bg-gradient-success {
            background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
          }

          .role-badge {
            display: inline-block;
            background: linear-gradient(135deg, #ffd700 0%, #ffed4e 100%);
            color: #000;
            padding: 4px 12px;
            border-radius: 20px;
            font-size: 0.75rem;
            font-weight: bold;
            margin-top: 8px;
          }

          .role-badge-alt {
            display: inline-block;
            background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
            color: white;
            padding: 4px 12px;
            border-radius: 20px;
            font-size: 0.75rem;
            font-weight: bold;
            margin-top: 8px;
          }

          .role-features li {
            font-size: 0.95rem;
          }

          /* Sports Section */
          .sports-section {
            background: #ffffff;
          }

          .sports-background {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-image: radial-gradient(
                circle at 30% 30%,
                rgba(102, 126, 234, 0.05) 0%,
                transparent 50%
              ),
              radial-gradient(
                circle at 70% 70%,
                rgba(118, 75, 162, 0.05) 0%,
                transparent 50%
              );
          }

          .sport-card {
            background: #f8f9fa;
            backdrop-filter: blur(10px);
            padding: 30px;
            border-radius: 20px;
            border: 1px solid #dee2e6;
            transition: all 0.3s ease;
          }

          .sport-card:hover {
            transform: translateY(-10px);
            background: #e9ecef;
            box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
          }

          .sport-emoji {
            font-size: 4rem;
            margin-bottom: 15px;
          }

          /* CTA Section */
          .cta-section {
            background: #f8f9fa;
          }

          .cta-background {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-image: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
          }

          /* Footer */
          .footer-pattern {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-image: linear-gradient(
                rgba(255, 255, 255, 0.05) 1px,
                transparent 1px
              ),
              linear-gradient(
                90deg,
                rgba(255, 255, 255, 0.05) 1px,
                transparent 1px
              );
            background-size: 50px 50px;
          }

          /* Animations */
          .animate-fade-in {
            animation: fadeIn 0.8s ease-in;
          }

          .animate-fade-in-delay-1 {
            animation: fadeIn 0.8s ease-in 0.2s backwards;
          }

          .animate-fade-in-delay-2 {
            animation: fadeIn 0.8s ease-in 0.4s backwards;
          }

          .animate-fade-in-delay-3 {
            animation: fadeIn 0.8s ease-in 0.6s backwards;
          }

          @keyframes fadeIn {
            from {
              opacity: 0;
              transform: translateY(30px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }

          .hover-grow {
            transition: transform 0.3s ease, box-shadow 0.3s ease;
          }

          .hover-grow:hover {
            transform: scale(1.05);
            box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2) !important;
          }

          .hover-link:hover {
            color: white !important;
            padding-left: 5px;
            transition: all 0.3s ease;
          }

          .stat-box {
            padding: 15px;
            border-radius: 15px;
            background: rgba(255, 255, 255, 0.1);
            backdrop-filter: blur(10px);
            border: 1px solid rgba(255, 255, 255, 0.2);
          }

          /* Responsive */
          @media (max-width: 768px) {
            .display-2 {
              font-size: 2.5rem;
            }
            .display-4 {
              font-size: 2rem;
            }
            .hero-illustration-3d {
              height: 300px;
            }
          }

          /* Dark Mode Styles */
          [data-theme="dark"] .landing-page section[style*="linear-gradient(180deg, #f8f9fa"] {
            background: linear-gradient(180deg, #1e1e2f 0%, #16213e 100%) !important;
          }

          [data-theme="dark"] .landing-page section[style*="linear-gradient(180deg, #ffffff"] {
            background: linear-gradient(180deg, #16213e 0%, #1e1e2f 100%) !important;
          }

          /* Feature Cards Dark Mode */
          [data-theme="dark"] .feature-card {
            background: #1e1e2f !important;
            border: 1px solid #4a4a6a !important;
          }

          [data-theme="dark"] .feature-card h3 {
            color: #e0e0e0;
          }

          [data-theme="dark"] .feature-card .text-muted {
            color: #a0a0a0 !important;
          }

          [data-theme="dark"] .feature-card:hover {
            box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3) !important;
          }

          /* Role Cards Dark Mode */
          [data-theme="dark"] .role-card {
            background: #1e1e2f !important;
            border: 1px solid #4a4a6a !important;
          }

          [data-theme="dark"] .role-card h3 {
            color: #e0e0e0;
          }

          [data-theme="dark"] .role-card .text-muted {
            color: #a0a0a0 !important;
          }

          [data-theme="dark"] .role-features li {
            color: #c0c0c0;
          }

          /* Sport Cards Dark Mode */
          [data-theme="dark"] .sport-card {
            background: #2d2d44 !important;
            border-color: #4a4a6a !important;
          }

          [data-theme="dark"] .sport-card:hover {
            background: #3d3d5c !important;
            box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3) !important;
          }

          [data-theme="dark"] .sport-card h3 {
            color: #e0e0e0;
          }

          [data-theme="dark"] .sport-card .text-muted {
            color: #a0a0a0 !important;
          }

          /* Workflow Steps Dark Mode */
          [data-theme="dark"] .workflow-step h3 {
            color: #e0e0e0;
          }

          [data-theme="dark"] .workflow-step .text-muted {
            color: #a0a0a0 !important;
          }

          /* Section Headings Dark Mode */
          [data-theme="dark"] .display-4 {
            color: #e0e0e0;
          }

          [data-theme="dark"] .lead {
            color: #a0a0a0;
          }

          [data-theme="dark"] .lead.text-muted {
            color: #a0a0a0 !important;
          }

          /* Guest Modal Dark Mode */
          [data-theme="dark"] .modal-content {
            background: #1e1e2f !important;
          }

          [data-theme="dark"] .modal-body {
            background: #1e1e2f;
          }

          [data-theme="dark"] .modal-body .text-muted {
            color: #a0a0a0 !important;
          }

          [data-theme="dark"] .modal-body .form-label {
            color: #e0e0e0;
          }

          [data-theme="dark"] .modal-body .form-control {
            background: #2d2d44;
            border-color: #4a4a6a;
            color: #e0e0e0;
          }

          [data-theme="dark"] .modal-body .form-control::placeholder {
            color: #808080;
          }

          [data-theme="dark"] .modal-footer.bg-light {
            background: #2d2d44 !important;
          }
        `}</style>
    </div>
  );
};

export default LandingPage;
